import React, { useContext, useEffect, useState } from "react";
import TableHeader from "../Utility/TableHeader";
import {
  ArrowPathIcon,
  EyeIcon,
  PencilSquareIcon,
} from "@heroicons/react/24/outline";
import DeleteConfirmation from "../Utility/DeleteConfirmation";
import { toast } from "react-toastify";
import axios from "axios";
import { DataContext } from "../../helper/HelperOne";
import { use } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Pagination } from "../../helper/HelperTwo";
import { Tooltip } from "react-tooltip";

function LeadList({
  setopenDialogBoxForLead,
  setLeadDetails,
  setSaveBtn,
  setLoading,
  leadPaginationData,
  setEditId,
  fetchLeadDatas,
  setIsEditing,
  setSaveBtnOpen,
  setEditLeadIdCrypty,
  id_crypt,
  showForm,
  filterParams,
}) {
  const currentLoginIdForAdmin = parseInt(localStorage.getItem("role_id"), 10); //current login oda user_id 1 ah irundha ? ella datas um show panrom
  const currentLoginIdForEmployee = JSON.parse(localStorage.getItem("user"))
    ?.employee?.id; // current login oda user la iruka employee oda id namba task la iruka task_member la iruka id oda match aachu apdina and employee oda tasks matum  list out panrom

  const filteredLeads =
    currentLoginIdForAdmin === 1
      ? leadPaginationData?.data || []
      : (leadPaginationData?.data || []).filter((task) =>
          task.lead_employee.some(
            (emp) =>
              parseInt(emp.id, 10) === parseInt(currentLoginIdForEmployee)
          )
        );

  const userForView = JSON.parse(localStorage.getItem("user"));
  const leadPermissionForView = userForView?.lead_role_based_access?.some(
    (access) => access.label_id == 6 && access.label_value != 0
  );

  const userForDelete = JSON.parse(localStorage.getItem("user"));
  const leadPermissionForDelete = userForDelete?.lead_role_based_access?.some(
    (access) => access.label_id == 4 && access.label_value != 0
  );

  const userForConvertToCustomer = JSON.parse(localStorage.getItem("user"));
  const convertToCustomerPermission =
    userForConvertToCustomer?.lead_role_based_access?.some(
      (access) => access.label_id == 5 && access.label_value != 0
    );

  const headers = [
    "S No",
    "Date",
    "Lead Name",
    "Phone",
    "Lead Employees",
    "Source",
    "Status",
    "Created By",
    "Action",
  ];

  const [leadAllDatas, setLeadAllDatas] = useState([]);
  const { searchData } = useContext(DataContext);
  const [leadId, setLeadId] = useState("");
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);

  const handleViewForLead = async (id_crypt) => {
    // setLoading(true);
    setIsEditing(true);
    setSaveBtnOpen(false);
    setEditLeadIdCrypty(id_crypt);
    setopenDialogBoxForLead(true);
    // setSaveBtn("update");
    setEditId(id_crypt);
    try {
      const response = await axios.get(
        `public/api/admin/lead/edit/${id_crypt}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      console.log(response.data, "response.data");
      

      setLeadDetails({
        date: response.data?.leads.date?.split(" ")[0],
        name: response.data?.leads.name,
        lead_status_id: response.data?.leads.lead_status?.id,
        lead_source_id: response.data?.leads.lead_source?.id,
        phone: response.data?.leads.phone,
        email_address: response.data?.leads.email_address,
        lead_date: response.data?.leads.lead_date,
        lead_value: response.data?.leads.lead_value,
        employees_id: response.data?.leads.lead_employee
          ? response.data?.leads.lead_employee.map((item) => item.id)
          : [],
        country_region_id: response.data?.leads.country_region_id,
        state_id: response.data?.leads.state_id,
        city: response.data?.leads.city,
        street_address_1: response.data?.leads.street_address_1,
        street_address_2: response.data?.leads.street_address_2,
        pincode: response.data?.leads.pincode,
        website: response.data?.leads.website,
        company: response.data?.leads.company,
        attention: response.data?.leads.attention,
        position: response.data?.leads.position,
        type_of_work: response.data?.leads.type_of_work.map((item) => item.id),
      });
    } catch (error) {
      toast.error(error.response.data?.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (showForm && id_crypt) {
      handleViewForLead(id_crypt);
    }
  }, [showForm, id_crypt]);

  const handleNavigateForTask = (leadIdCrypt, leadId) => {
    navigate(`/crm/lead_task`, {
      state: { leadIdCrypt, leadId },
    });
  };

  const handleConvertToCustomer = async (id_crypt) => {
    try {
      const response = await axios.post(
        `public/api/admin/lead/converttocustomer/${id_crypt}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      toast.success(response.data.message);
      await fetchLeadDatas(currentPage);
    } catch (error) {
      toast.error(error.response.data.message);
    }
  };

  const handlePageChange = (page) => {
    if (page !== "..." && !isNaN(page)) {
      const newPage = Number(page);
      setCurrentPage(newPage);
      fetchLeadDatas(newPage, filterParams);
    }
  };

  return (
    <>
      <div className="overflow-x-auto mt-8">
        <table className="min-w-full divide-y divide-gray-300">
          <TableHeader headers={headers} />
          <tbody className="divide-y divide-gray-200 bg-white">
            {filteredLeads?.length > 0 ? (
              filteredLeads.map((lead, index) => (
                <tr
                  key={index}
                  className="hover:bg-gray-50 transition duration-300 ease-in-out"
                >
                  <td className="whitespace-nowrap text-md sm:pl-4 text-center">
                    {leadPaginationData.from + index}
                  </td>
                  <td className="whitespace-nowrap text-md text-gray-500 sm:pl-4 text-center"> 
                    {lead.date?.split(" ")[0]}
                  </td>
                  <td className="whitespace-nowrap text-md text-gray-500 sm:pl-4 text-center">
                    <span
                      className="my-anchor-add text-blue-500 cursor-pointer hover:text-blue-600 font-normal"
                      onClick={() => handleNavigateForTask(lead.id_crypt)}
                    >
                      {lead.name}
                    </span>
                  </td>
                  <td className="whitespace-nowrap text-md text-gray-500 sm:pl-4 text-center">
                    {lead.phone}
                  </td>
                  <td className="whitespace-nowrap text-md text-gray-500 sm:pl-4 text-center">
                    {lead.lead_employee
                      ? lead.lead_employee.map((item) => item.name).join(", ")
                      : "N/A"}
                  </td>
                  <td className="whitespace-nowrap text-md text-gray-500 sm:pl-4 text-center">
                    {lead.lead_source?.name ?? "N/A"}
                  </td>
                  <td className="whitespace-nowrap text-md text-gray-500 sm:pl-4 text-center">
                    <span
                      className={`border rounded px-2 py-1 ${
                        lead.lead_status?.name === "Pending"
                          ? "border-blue-600 text-blue-600"
                          : lead.lead_status?.name === "Completed"
                          ? "border-green-600 text-green-600"
                          : lead.lead_status?.name === "Not Yet Started"
                          ? "border-red-500 text-red-500"
                          : lead.lead_status?.name === "Converted"
                          ? "border-purple-600 text-purple-600"
                          : "border-gray-400 text-gray-600"
                      }`}
                    >
                      {lead.lead_status?.name}
                    </span>
                  </td>

                  <td className="whitespace-nowrap text-md text-gray-500 sm:pl-4 text-center">
                    {lead.created_by?.name}
                  </td>
                  <td className="flex space-x-2 items-center justify-center py-4 text-center text-sm text-gray-500 font-semibold">
                    {leadPermissionForView && (
                      <span
                        className="my-anchor-view relative group cursor-pointer bg-blue-400 rounded-md p-1"
                        onClick={() =>
                          handleViewForLead(
                            lead.id_crypt,
                            setopenDialogBoxForLead
                          )
                        }
                      >
                        <EyeIcon className="h-5 w-5 text-white" />
                        <Tooltip
                          anchorSelect=".my-anchor-view"
                          place="top"
                          className="text-xs p-0"
                          style={{ fontSize: "12px", padding: "0.3rem" }}
                        >
                          View
                        </Tooltip>
                      </span>
                    )}

                    {leadPermissionForDelete && (
                      <DeleteConfirmation
                        id_crypt={lead.id_crypt}
                        apiType={"lead"}
                        fetchClientData={fetchLeadDatas}
                      />
                    )}

                    {convertToCustomerPermission && (
                      <button
                        className="my-anchor-customer relative group cursor-pointer bg-purple-400 rounded-md p-1"
                        onClick={() => handleConvertToCustomer(lead.id_crypt)}
                      >
                        <ArrowPathIcon className="h-5 w-5 text-white" />
                        <Tooltip
                          anchorSelect=".my-anchor-customer"
                          place="left"
                          className="text-xs p-0"
                          style={{ fontSize: "12px", padding: "0.3rem" }}
                        >
                          Convert to customer
                        </Tooltip>
                      </button>
                    )}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="9" className="text-center py-4 text-gray-500">
                  No leads found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* {filteredLeads?.length > 0 ? (
  <Pagination
    links={leadPaginationData.links} // Keep original links for navigation
    currentPage={leadPaginationData.current_page}
    totalResults={filteredLeads.length} // Update total results based on filtered data
    from={filteredLeads.length > 0 ? 1 : 0} // Start from 1 if results exist
    to={filteredLeads.length} // Show the total count as the last item
    lastPage={Math.ceil(filteredLeads.length / leadPaginationData.per_page)} // Calculate last page dynamically
    onPageChange={handlePageChange}
  />
) : (
  leadPaginationData && (
    <Pagination
      links={leadPaginationData.links}
      currentPage={leadPaginationData.current_page}
      totalResults={leadPaginationData.total}
      from={leadPaginationData.from}
      to={leadPaginationData.to}
      lastPage={leadPaginationData.last_page}
      onPageChange={handlePageChange}
    />
  )
)} */}

      {leadPaginationData && (
        <Pagination
          links={leadPaginationData.links}
          currentPage={leadPaginationData.current_page}
          totalResults={leadPaginationData.total}
          from={leadPaginationData.from}
          to={leadPaginationData.to}
          lastPage={leadPaginationData.last_page}
          onPageChange={handlePageChange}
        />
      )}
    </>
  );
}

export default LeadList;
